export default class {
  init() {
    const $elements = $("section.testimonials-carousel .slick-slider");

    if ($elements.length) {
      (async () => {
        await import("slick-carousel");

        $elements
          .on("init", () => {
            window.App.aos.refreshHard();
          })
          .slick({
            arrows: false,
            dots: false,
            centerMode: true,
            slidesToShow: 3,
            responsive: [
              {
                breakpoint: 992,
                settings: {
                  slidesToShow: 1,
                },
              },
              {
                breakpoint: 768,
                settings: {
                  centerPadding: "20px",
                  slidesToShow: 1,
                },
              },
            ],
          });
      })();
    }
  }
}
